import { IBank } from '@common/interfaces/bank'
import { combineReducers } from 'redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.CREATE_REQUEST:
      case actions.LIST_REQUEST:
        return [...state, action.type]
      case actions.CREATE_SUCCESS:
      case actions.CREATE_FAILURE:
      case actions.LIST_SUCCESS:
      case actions.LIST_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  list(state: IBank[] = [], action: IAction): IBank[] {
    switch (action.type) {
      case actions.CREATE_SUCCESS:
        return [...state, action.data as IBank]
      case actions.LIST_SUCCESS:
        return action.data as IBank[]
      default:
        return state
    }
  },
})
